import React from 'react'
import PropTypes from 'prop-types'
import { Paragraph, H3 } from '@fs/zion-ui'

export default function StoryCardBody({ data }) {
  return (
    <div style={{ whiteSpace: 'pre-wrap' }}>
      <H3 size="H5">{data?.headline}</H3>
      <Paragraph size="sm">{data?.description}</Paragraph>
    </div>
  )
}

// Stryker disable all
StoryCardBody.propTypes = {
  /** Data to display for StoryCard including the images and description */
  data: PropTypes.shape({}),

  /** Person object for the person who's data is being displayed. */
  person: PropTypes.shape({}),
}
